<template>
  <el-select
    class="SelectSearchSocial"
    v-model="searchNickName"
    :multiple="!!otherParam.isMultiple"
    collapse-tags
    filterable
    remote
    reserve-keyword
    :disabled="disabled"
    :placeholder="$t('lang.occasionalOutput')"
    :no-match-text="$t('lang.createOutputTips')"
    popper-class="selectSocialAccount"
    v-scroll="scrollData"
    :popper-append-to-body="false"
    :multiple-limit="3"
    :remote-method="SearchOutputList"
    :loading="loadingFlag"
    @change="getSelectInfo"
    @visible-change="getMediaSource">
    <el-option
      v-for="item in OutputList"
      :key="item.id"
      :label="item.nickName"
      :value="item.id">
      <span class="logo">
        <svg
          class="svgicon"
          aria-hidden="true"
        >
          <use :xlink:href="IconFilter(item, item.type)" />
        </svg>
      </span>
      <span class="name">{{ item.nickName }}</span>
    </el-option>
  </el-select>
</template>
<script>
import { SocialPlatform, ChannelList } from '@/config.js'
export default {
  props: {
    selectedAccount: {
      type: Array,
      default: () => []
    },
    otherParam: {
      type: Object,
      default: () => {
        return { isMultiple: 1 }
      }
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      SocialPlatform,
      ChannelList,
      OutputList: [],
      scrollData: {
        onScroll: this.handleAccountScroll,
        distance: 15,
        directive: '.el-select-dropdown__list'
      },
      loadingFlag: false,
      totalPages: 0,
      searchNickName: [],
      singleNickName: '',
      isInstand: true,
      params: {
        nickName: '',
        targetId: '',
        secondType: '',
        importType: '',
        pageSize: 15,
        pageNum: 1
      }
    }
  },
  created () {
    const AccountList = []
    this.selectedAccount.forEach((item) => {
      if (this.otherParam.isMultiple) {
        this.searchNickName.push(item.outputId)
      } else {
        this.searchNickName = item.outputId
      }
      AccountList.push({
        id: item.outputId,
        nickName: item.outputName
      })
    })
    this.OutputList = JSON.parse(JSON.stringify(AccountList))
  },
  methods: {
    // 选中之后传出
    getSelectInfo (val) {
      const SelectInfo = []
      this.OutputList.forEach((item) => {
        if (this.otherParam.isMultiple) {
          if (val.includes(item.id)) {
            SelectInfo.push({
              outputId: item.id,
              outputName: item.nickName
            })
          }
        } else {
          if (val == item.id) {
            SelectInfo.push({
              outputId: item.id,
              outputName: item.nickName
            })
          }
        }
      })
      this.$emit('AccountSelectInfo', SelectInfo)
    },
    // 搜索
    SearchOutputList (val) {
      this.params.nickName = val
      this.params.pageNum = 1
      this.params.pageSize = 15
      this.isInstand = true
      this.getMediaSource()
    },
    // 滚动加载
    handleAccountScroll () {
      if (this.isInstand) {
        this.params.pageNum++
        this.getMediaSource()
      }
    },
    // 获取推流列表
    getMediaSource (key) {
      if (key == false) {
        return
      } else if (key) {
        this.params.pageNum = 1
        this.params.nickName = ''
      }
      if (this.params.pageNum == 1) this.loadingFlag = true // 只有第一页的时候才添加loading效果
      this.params.targetId = mediaObj.programId
      this.params.secondType = mediaObj.supportPlatform
      if (mediaObj.ownerId != '' && mediaObj.currentUserId != '' && mediaObj.userIdList.length) {
        // 如果当前用户是Owner，需要所有分享用户的id，如果当前用户是User，则只用给Owner和User的id
        if (mediaObj.ownerId.toLowerCase() == mediaObj.currentUserId.toLowerCase()) {
          this.params.allUserIds = JSON.parse(JSON.stringify(mediaObj.userIdList))
        } else {
          this.params.allUserIds = [mediaObj.ownerId, mediaObj.currentUserId]
        }
      }
      SM.__proto__.getOutputList(this.params).then((res) => {
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          const outputList = data.list || []
          this.totalPages = data.pages
          if (this.params.pageNum == data.pages) this.isInstand = false
          // 搜索时没有数据置空
          if (this.searchNickName && this.params.pageNum == 1 && !outputList || !outputList.length) {
            this.OutputList = []
            this.loadingFlag = false
            return
          }
          outputList.forEach((item) => {
            // 分享判断当前social类型账号是否属于自己，限制是否可编辑
            if (item.importType == 'social') {
              item.isSelfAccount = mediaObj.currentUserId == '' || mediaObj.currentUserId != '' && mediaObj.currentUserId.toLowerCase() == item.userId.toLowerCase()
            } else {
              item.isSelfAccount = true
            }
          })
          if (this.params.pageNum == 1) {
            this.OutputList = outputList.concat([])
          } else {
            this.OutputList = this.OutputList.concat(outputList)
          }
          this.loadingFlag = false
        } else {
          this.loadingFlag = false
        }
      }).catch(() => {
        this.loadingFlag = false
      })
    },
    // 过滤图标显示
    IconFilter (obj, key) {
      if (obj.importType && obj.importType == 'social') {
        const Accounts = this.SocialPlatform.filter((item) => item.type == key)
        let icon = ''
        if (Accounts.length > 0 && Accounts[0].icon) {
          icon = Accounts[0].icon
        } else {
          icon = '#icon-Rtmpgreen'
        }
        if (key == 'Y' && obj.authType != 0) icon = Accounts[0].icon2
        return icon
      } else {
        const Accounts = this.ChannelList.filter((item) => item.name == key)
        let icon = ''
        if (Accounts.length > 0 && Accounts[0].icon) {
          icon = Accounts[0].icon
        } else {
          icon = '#icon-a-otheroutput'
        }
        return icon
      }
    }
  }
}
</script>
<style lang="less" scoped>
.SelectSearchSocial {
  width: 100%;
  .logo,.svgicon {
    width: 20px;
  }
}
::v-deep .el-scrollbar__wrap {
  height: 214px !important;

  .el-scrollbar__view {
    height: 210px !important;
    overflow-y: auto;

    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      background-color: rgba(144, 147, 153, 0.2);
      opacity: 0.7;
    }

    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      border-radius: 10px;
      background: none;
    }
  }
}
::v-deep .el-select-dropdown__item {
  padding: 0 14px;
  width: 100%;
}
</style>
